import React from "react";
import { FaAngleDoubleRight } from "../shared/icons";

const DoubleArrow = () => {
  return (
    <div className="doubleArrow">
      <FaAngleDoubleRight />
    </div>
  );
};

export default DoubleArrow;
